import Script from "next/script"

export default function Analytics() {
  const gtmId = process.env.GTM_ID

  if (!gtmId) {
    return null
  }

  // Load GTM with the standard Google snippet using `beforeInteractive` so the
  // container is fetched and executed before hydration (no measurement lost in
  // the pre-hydration window). Must live in the root layout to take effect.
  // `sendGTMEvent` (@next/third-parties) keeps working — it pushes to the same
  // `window.dataLayer` this snippet creates.
  return (
    <Script id="gtm-base" strategy="beforeInteractive">
      {`(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','${gtmId}');`}
    </Script>
  )
}

// Part 2 of the standard GTM snippet: the <noscript> fallback for visitors with
// JavaScript disabled. Must be rendered as the first element inside <body>.
export function GtmNoScript() {
  const gtmId = process.env.GTM_ID

  if (!gtmId) {
    return null
  }

  return (
    <noscript>
      <iframe
        src={`https://www.googletagmanager.com/ns.html?id=${gtmId}`}
        height="0"
        width="0"
        style={{ display: "none", visibility: "hidden" }}
      />
    </noscript>
  )
}
